import { useNavigate } from 'react-router-dom';


const UnassignedDevicesTable = ({ devices }) => {
    const navigate = useNavigate();

    if (!devices || devices.length === 0) {
        return null;
    }

    return (
        <div className="unassigned-devices-container">
            <h3>Unassigned devices</h3>
            <div className="data-transmission-table-container">
                <table>
                    <colgroup>
                        <col style={{width: "55%"}}/>
                        <col style={{width: "25%"}}/>
                        <col style={{width: "20%"}}/>
                    </colgroup>
                    <tbody>
                        <tr style={{fontWeight: "bold"}}>
                            <th>SN</th>
                            <th>Registered</th>
                            <th>Action</th>
                        </tr>
                        {devices.map((device) => (
                            <tr key={device.id}>
                                <td className="device-registration-sn">{device.sn}</td>
                                <td>
                                    {new Date(device.created_at).toLocaleString("pl-PL")}
                                </td>
                                <td>
                                    <button
                                        className="device-assignment-button"
                                        onClick={() => navigate(`/device-registration/${device.id}/assign`)}
                                    >
                                        Assign
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};


export default UnassignedDevicesTable;
